export const DEFAULT_FONT_SIZE = 20;
export const SVG_TO_SHAPE_MAPPER = {
    rect: "rectangle",
    circle: "ellipse",
};
